<template>
  <v-snackbar :value="visible" light :timeout="-1" bottom right color="dark">
    <span>{{ $t("gdpr.message") }} </span>
    <template #action>
      <v-btn dark @click="accept()">{{ $t("common.accept") }}</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
const KEY = "GDPR_accepted"
export default {
  data: () => ({
    visible: false,
  }),

  mounted() {
    if (localStorage.getItem(KEY, true) !== "1") {
      this.visible = true
    }
  },

  methods: {
    accept() {
      this.visible = false
      localStorage.setItem(KEY, "1")
    },
  },
}
</script>
